import { MyOskSubscriptionsAssignHistoryService } from '../../../../api/api-services/my-osk-subscriptions-assign-history.service';
import { IMyOskSubscriptonHistoryVm } from '../../../../api/my-osk-subscripton-history-vm.model';
import { SortOrder } from '../../../../api/sort-order.model';
import { FASDynamicTableColumnConfig } from 'fas-services';
import { Component, inject } from '@angular/core';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'app-osk-history-subscriptions-list',
  templateUrl: './osk-history-subscriptions-list.component.html',
  styleUrl: './osk-history-subscriptions-list.component.scss'
})
export class OskHistorySubscriptionsListComponent {
  private _myOskSubscriptionsAssignHistoryService = inject(MyOskSubscriptionsAssignHistoryService);
  public columns: FASDynamicTableColumnConfig<IMyOskSubscriptonHistoryVm>[] = [
    {
      field: 'planName',
      columnHeader: 'Nazwa abonamentu',
      columnTemplateKey: 'planNameTemplate',
    },
    {
      field: 'assignedDateTime',
      columnHeader: 'Data przypisania',
      dateField: true
    },
    {
      field: 'studentName',
      columnHeader: 'Przypisany kursant (adres email)',
      columnTemplateKey: 'studentNameTemplate',

    },
  ];


  fetchOskSubscriptionHistory = (params: {
    page: number;
    pageSize: number;
    sortField?: keyof IMyOskSubscriptonHistoryVm;
    sortOrder?: number;
    search?: string;
  }): Observable<{ data: IMyOskSubscriptonHistoryVm[]; total: number }> => {
    const { page, pageSize, sortField = '', sortOrder, search = '' } = params;
    const sortOrderValue =
      sortOrder === 1 ? SortOrder.Ascending : SortOrder.Descending;
    return this._myOskSubscriptionsAssignHistoryService.get(search, sortField, page, pageSize).pipe(
      map((result) => ({
        data: result.data ?? [],
        total: result.allElementsCount,
      }))
    );
  };


}
